import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import Layout from "../Common/Layout";
import AdminList from "./AdminList";

const CreateAdmin = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = sessionStorage.getItem("token");
    if (!token) {
      toast.error("Unauthorized! Please login again.");
      return;
    }

    try {
      const response = await fetch(
        "https://irc.zentelex.com/api/admin/create-admin",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            name: formData.name,
            email: formData.email,
            password: formData.password,
          }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        toast.success("Admin created successfully!");
        setFormData({ name: "", email: "", password: "" });
      } else {
        toast.error(data.message || "Failed to create admin");
      }
    } catch (error) {
      console.error("Create Admin Error:", error);
      toast.error("Server error!");
    }
  };

  return (
    <Layout>
      <div className="container mt-4">
        <div
          className="card shadow-lg p-4 mx-auto"
          style={{
            maxWidth: "600px",
            backgroundColor: "#3075A6",
            color: "white",
          }}
        >
          <h3 className="text-center mb-4">Create Admin</h3>

          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">Name</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="form-control"
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="form-control"
                required
              />
            </div>

            <div className="mb-4">
              <label className="form-label">Password</label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                className="form-control"
                required
              />
            </div>

            <button
              className="btn w-100"
              style={{
                backgroundColor: "#EC662C",
                color: "white",
              }}
            >
              Create Admin
            </button>
          </form>
        </div>
      </div>

      <div>
        <AdminList onClickButton={handleSubmit} ></AdminList>
      </div>

      <ToastContainer />
    </Layout>
  );
};

export default CreateAdmin;
